import { Condition } from '../@types/Condition';
import { Valuation } from '../@types/Valuation';
import { sendRequest } from './http';

const getValuation = async (
  url: string,
  registrationNumber: string,
  km?: number,
  condition?: Condition
) => {
  const params = new URLSearchParams();
  params.set('regNo', registrationNumber);
  if (km) {
    params.set('km', km.toString());
  }
  if (condition) {
    params.set('condition', condition);
  }

  return await sendRequest<Valuation>({
    method: 'GET',
    url: `${url}/wip/external/vehicle?${params.toString()}`,
  });
};

export const getValuationErrorMessage = (status?: number) => {
  switch (status) {
    case 404:
      return 'Tyvärr fick vi ingen träff på registreringsnummret du angav. Vänligen kontrollera att registreringsnummret stämmer.';
    default:
      return 'Ett fel har inträffat, försök igen.';
  }
};

export default getValuation;
